import {
  Box,
  Grid,
  Typography,
  Card,
  CardContent,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Divider,
  Alert,
  CircularProgress,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import DownloadIcon from "@mui/icons-material/Download";
import ScoreIcon from "@mui/icons-material/Score";
import ScheduleIcon from "@mui/icons-material/Schedule";
import "./Files.css";

const DashboardTemplate = () => {
  // Available documents for download
  const documents = [
    {
      name: "Competition Agenda 2026",
      link: "https://drive.google.com/uc?export=download&id=1hSs7g--hzd_4tw5ZwCy2EIYtGJNKj_sT",
      filename: "IRC_Agenda_2026.pdf",
    },
    {
      name: "RC Code Schedule 2026",
      link: "https://drive.google.com/uc?export=download&id=11S5uJgvr96IUGJHlc9osc71hRfcH14Qp",
      filename: "RC_Code_2026.pdf",
    },
    {
      name: "Robo Boom Challenge Schedule 2026",
      link: "https://drive.google.com/uc?export=download&id=1XuGJ4XWtNWNj778ZdR-4TDwW6TNBUXX5",
      filename: "Robo_boom_2026.pdf",
    },
    {
      name: "Robo Boom Construction Schedule 2026",
      link: "https://drive.google.com/uc?export=download&id=12QPt9XeMVibK7GTrAOflf2YVoIuzA1JX",
      filename: "Robo_boom_2026.pdf",
    },
    {
      name: "Robo Boom Curling Schedule 2026",
      link: "https://drive.google.com/uc?export=download&id=1tq5TzmjZJqB-bt8qS4ADtxV_kFsu9tTI",
      filename: "Robo_boom_2026.pdf",
    },
    {
      name: "Robo Boom Discover Schedule 2026",
      link: "https://drive.google.com/uc?export=download&id=1iWwmUBbdG-6MTEcdK2Kfm9XZ3ND8cwM8",
      filename: "Robo_boom_2026.pdf",
    },
    {
      name: "Robo Boom Line Sprint Schedule 2026",
      link: "https://drive.google.com/uc?export=download&id=1szp4tMSLXYBzFx3BhM32_aSV-Q_9lPVl",
      filename: "Robo_boom_2026.pdf",
    },
    {
      name: "Bowling Schedule 2026",
      link: "https://drive.google.com/uc?export=download&id=1k1IWbPBRhtXaILwWlIw3ESzQTRoWVMfx",
      filename: "Bowling_2026.pdf",
    },
    {
      name: "Follow line (Enhanced) Schedule 2026",
      link: "https://drive.google.com/uc?export=download&id=1PMGVITvwpAkFqsht8ItTpgEWQamMFk9C",
      filename: "Follow_line_enhanced_2026.pdf",
    },
    {
      name: "Follow line (Open) Schedule 2026",
      link: "https://drive.google.com/uc?export=download&id=1Vgw0OphWufpOhj75OL13LJQNu_h6uyBR",
      filename: "Follow_line_open_2026.pdf",
    },
    {
      name: "Follow line (Lego) Schedule 2026",
      link: "https://drive.google.com/uc?export=download&id=1Vgw0OphWufpOhj75OL13LJQNu_h6uyBR",
      filename: "Follow_line_lego_2026.pdf",
    },
    {
      name: "Free Style Schedule 2026",
      link: "https://drive.google.com/uc?export=download&id=1xu9HDC4JnB9X-ydABdSOxqd1cSh-Khj4",
      filename: "Free_style_2026.pdf",
    },
    {
      name: "Puck Collect Schedule 2026",
      link: "https://drive.google.com/uc?export=download&id=1NbW4Wq_MsI7YdMfVEgJiaK5nJg5Uo6by",
      filename: "Puck_collect_2026.pdf",
    },
    {
      name: "Robo Golf Schedule 2026",
      link: "https://drive.google.com/uc?export=download&id=1P6G08IU89JmhHK_04C9eBZrD09zFOoPr",
      filename: "Robo_golf_2026.pdf",
    },
    {
      name: "Sumo (Mega) Schedule 2026",
      link: "https://drive.google.com/uc?export=download&id=1DC9BcmLRKbS_IJIcx_vleR7QiJdFs5zl",
      filename: "Sumo_mega_2026.pdf",
    },
    {
      name: "Sumo (Mini) Schedule 2026",
      link: "https://drive.google.com/uc?export=download&id=1fit7I24hD8dz1rf5e1x2KQXOf9UFedwV",
      filename: "Sumo_mini_2026.pdf",
    },
    {
      name: "Sumo (Lego) Schedule 2026",
      link: "https://drive.google.com/uc?export=download&id=1R9Aq-DTVLERTBpC9wOSn7oZSSD7dMGa4",
      filename: "Sumo_lego_2026.pdf",
    },
  ];

  const handleDownload = (document) => {
    window.open(document.link, "_blank");
  };

  return (
    <Box
      sx={{
        width: "100%",
        padding: { xs: "50px 20px", sm: "50px 60px", lg: "50px 120px" },
        maxWidth: "1500px",
        margin: "auto",
        minHeight: "80vh",
      }}
    >
      <Typography
        variant={"h1"}
        sx={{
          textAlign: "center",
          fontSize: { xs: "40px", sm: "50px" },
          fontWeight: "500",
          color: "primary.darker",
        }}
      >
        Robot Challenge Egypt 2026
      </Typography>
      <Box
        sx={{
          height: "3px",
          maxWidth: { xs: "100px", md: "150px" },
          width: "100%",
          backgroundColor: "primary.main",
          margin: "auto",
          marginBottom: "50px",
          marginTop: "10px",
        }}
      />

      <Grid container spacing={4}>
        {/* Documents Section */}
        <Grid item xs={12} lg={12}>
          <Card sx={{ height: "100%" }}>
            <CardContent>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "20px",
                }}
              >
                <ScheduleIcon
                  sx={{
                    color: "primary.main",
                    marginRight: "10px",
                    fontSize: "30px",
                  }}
                />
                <Typography
                  variant="h4"
                  sx={{ color: "primary.darker", fontWeight: "600" }}
                >
                  Competition Schedules
                </Typography>
              </Box>

              <Typography
                variant="body1"
                sx={{ color: "primary.darker", marginBottom: "20px" }}
              >
                Download the latest competition agenda, schedules, and other
                important documents.
              </Typography>

              <Grid container spacing={2}>
                {documents.map((doc, index) => (
                  <Grid item xs={12} md={6} lg={4} key={index}>
                    <Card
                      variant="outlined"
                      sx={{
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                        "&:hover": {
                          boxShadow: 3,
                          transform: "translateY(-2px)",
                        },
                      }}
                      onClick={() => handleDownload(doc)}
                    >
                      <CardContent sx={{ padding: "16px !important" }}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <Box>
                            <Typography
                              variant="h6"
                              sx={{
                                color: "primary.darker",
                                fontWeight: "600",
                              }}
                            >
                              {doc.name}
                            </Typography>
                            {/* <Typography
                              variant="body2"
                              sx={{ color: "text.secondary" }}
                            >
                              {doc.description}
                            </Typography> */}
                          </Box>
                          <DownloadIcon sx={{ color: "primary.main" }} />
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default DashboardTemplate;
